var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart-simple-solid",
    d: "M8.571,34.571A2.572,2.572,0,0,1,11.143,32h1.714a2.572,2.572,0,0,1,2.571,2.571V53.429A2.572,2.572,0,0,1,12.857,56H11.143a2.572,2.572,0,0,1-2.571-2.571ZM0,44.857a2.572,2.572,0,0,1,2.571-2.571H4.286a2.572,2.572,0,0,1,2.571,2.571v8.571A2.572,2.572,0,0,1,4.286,56H2.571A2.572,2.572,0,0,1,0,53.429Zm19.714-9.429h1.714A2.572,2.572,0,0,1,24,38V53.429A2.572,2.572,0,0,1,21.429,56H19.714a2.572,2.572,0,0,1-2.571-2.571V38A2.572,2.572,0,0,1,19.714,35.429Z",
    transform: "translate(0 -32)",
    fill: "inharit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.bb38e06ccfbde99b03a3e5f9d16c0e6d.svg";
export { ForwardRef as ReactComponent };